var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceivedMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.57,
    height: 27.374,
    viewBox: "0 0 31.57 27.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;opacity:0.6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.637,0H4.933A4.938,4.938,0,0,0,0,4.933V19.176a4.938,4.938,0,0,0,4.933,4.933h7.831a1.233,1.233,0,1,0,0-2.466H4.933a2.469,2.469,0,0,1-2.466-2.466V5.28L13.18,11.942a4.9,4.9,0,0,0,5.21,0L29.1,5.28v6.682a1.233,1.233,0,1,0,2.466,0V4.933A4.938,4.938,0,0,0,26.637,0Zm-9.55,9.848a2.451,2.451,0,0,1-2.6,0L3.433,2.977a2.453,2.453,0,0,1,1.5-.51h21.7a2.453,2.453,0,0,1,1.5.51Zm14.252,7.761-6.1,8.525c-.013.019-.027.037-.041.054a3.179,3.179,0,0,1-2.261,1.178c-.07,0-.14.007-.209.007a3.18,3.18,0,0,1-2.188-.874L16.6,22.717a1.233,1.233,0,0,1,1.708-1.779l3.935,3.779a.7.7,0,0,0,1.014-.053l6.079-8.491a1.233,1.233,0,0,1,2.006,1.436Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivedMessage);
export default __webpack_public_path__ + "static/media/received-message.e02daadd9d2f9fed2bf978fd3cfa47c2.svg";
export { ForwardRef as ReactComponent };